export var TableNode;
(function (TableNode) {
    TableNode["Table"] = "table";
    TableNode["Head"] = "thead";
    TableNode["Body"] = "tbody";
    TableNode["Row"] = "tr";
    TableNode["HeaderCell"] = "th";
    TableNode["DataCell"] = "td";
})(TableNode || (TableNode = {}));
export var TableAttrs;
(function (TableAttrs) {
    TableAttrs["CellAlign"] = "cell-align";
})(TableAttrs || (TableAttrs = {}));
export var CellAlign;
(function (CellAlign) {
    CellAlign["Left"] = "left";
    CellAlign["Center"] = "center";
    CellAlign["Right"] = "right";
})(CellAlign || (CellAlign = {}));
